import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { PointsAccountFacade } from '@features/points-account/facades/points-account/points-account.facade';
import { filter, map, Observable, takeWhile, withLatestFrom } from 'rxjs';

@Injectable()
export class MultiCardSelectGuard implements CanActivate {
  constructor(
    private router: Router,
    private pointsAccountFacade: PointsAccountFacade,
  ) {}

  canActivate(): Observable<boolean> {
    // This is to account for the case where a user manually enters the `select-card` url and they only have one card
    // In that case we redirect them to the home page
    return this.pointsAccountFacade.pointsAccounts$.pipe(
      withLatestFrom(this.pointsAccountFacade.loadPointsAccountsLoading$),
      // A user should always have a points account of length > 0
      // Length of 0 is just the default value from the store
      filter(([pointsAccounts]) => pointsAccounts.length > 0),
      takeWhile(([_, loading]) => loading, true),
      map(([pointsAccounts]) => {
        if (pointsAccounts.length < 2) {
          this.router.navigateByUrl('/');
          return false;
        } else {
          return true;
        }
      }),
    );
  }
}
